import { css } from "emotion";
import { Component } from "preact";
import { connect } from "react-redux";
import Content from "../../components/Content";
import Page from "../../components/Page";
import Config from "../../config";
import {
  getGiftCardEvents,
  getGiftCardPage
} from "../../state/actions/giftCardActions";
import OrganiserEvents from "../organiser/OrganiserEvents";
import GiftCard from "./GiftCard";
import arrowLeftIcon from "../../assets/images/icon-arrow-left-blue.svg";

const giftCardStyleMap = {
  default: "#6621c0",
  royal: "#8D721E",
  breeze: "#1E72D6"
};

const giftCardStyle = css({
  width: 500,
  height: 270,
  margin: "auto",
  "@media (max-width: 800px)": {
    width: 292,
    height: 158
  }
});

const eventListStyle = css({
  margin: "auto",
  maxWidth: 800,
  "@media (max-width: 800px)": {
    padding: "0px 14px"
  }
});

class GiftCardEventPage extends Component {
  constructor(props) {
    super(props);
  }

  componentWillMount() {
    const {
      giftCardSlug,
      getGiftCardPage,
      getGiftCardEvents,
      giftCardTypeId
    } = this.props;
    getGiftCardPage(giftCardSlug);
    getGiftCardEvents(giftCardTypeId, 0);
  }

  nextPage = () => {
    const { giftCards, giftCardTypeId, getGiftCardEvents } = this.props;
    const { events } = giftCards;
    const { page } = events;
    getGiftCardEvents(giftCardTypeId, page + 1);
  };

  previousPage = () => {
    const { giftCards, giftCardTypeId, getGiftCardEvents } = this.props;
    const { events } = giftCards;
    const { page } = events;
    getGiftCardEvents(giftCardTypeId, page - 1);
  };

  render() {
    const { giftCards, giftCardTypeId } = this.props;
    const { giftCardPage, giftCardList, events } = giftCards;
    if (giftCards.loading || !giftCards.giftCardPage) {
      return (
        <Page>
          <Content>
            <div class="loading loading-lg" style={{ minHeight: 500 }} />
          </Content>
        </Page>
      );
    }
    const giftCardType = giftCardList.find(
      giftCard => giftCard._id === giftCardTypeId
    );
    const moreEvents = (
      <div className={eventListStyle}>
        <div style={{ margin: "auto", marginTop: 32 }}>
          <h2>Available to use on these events</h2>
          <div
            style={{
              borderBottom: "solid 1px #dedede",
              marginTop: 12,
              marginBottom: 18
            }}
          />
          <OrganiserEvents
            events={events.list}
            nextPage={this.nextPage}
            previousPage={this.previousPage}
            page={events.page}
            numEvents={events.total}
            loadingEvents={events.loading}
            size={"large"}
            maxWidth={"100%"}
          />
        </div>
      </div>
    );
    return (
      <div style={{ backgroundColor: "#f9f9fa", paddingBottom: 70 }}>
        <Page
          border={true}
          maxWidth={800}
          banner={
            <Header
              link={`${Config("TICKETING_URL")}/gift-cards/${
                giftCardPage.slug
              }`}
            />
          }
          isGlobal={false}
        >
          <Content>
            <GiftCardHeader giftCardType={giftCardType} />
          </Content>
        </Page>
        {moreEvents}
      </div>
    );
  }
}

const GiftCardHeader = ({ giftCardType }) => {
  const { style, price, name, companyLogo } = giftCardType;
  const backgroundColor =
    style.type === "custom"
      ? style.backgroundColor
      : giftCardStyleMap[style.type];
  return (
    <div style={{ padding: "24px 12px" }}>
      <div className={giftCardStyle}>
        <GiftCard
          backgroundColor={backgroundColor}
          name={name}
          showNumber={false}
          showExpiry={false}
          amount={price}
          image={companyLogo}
        />
      </div>
    </div>
  );
};

const headerStyle = css({
  width: "100%",
  position: "relative",
  backgroundColor: "white",
  minHeight: 70,
  paddingLeft: 60,
  paddingRight: 14,
  paddingBottom: 26,
  paddingTop: 22,
  display: "flex",
  boxShadow: "0 0 1px 0 #f1f1f1, 0 1px 3px 0 rgba(9, 30, 66, 0.13)",
  zIndex: 100,
  "@media (max-width: 800px)": {
    display: "block",
    paddingTop: 16,
    minHeight: 56,
    paddingLeft: 14,
    paddingBottom: 19
  }
});

const linkStyle = css({
  background: `url(${arrowLeftIcon}) no-repeat left center`,
  svg: {
    fill: "#196097"
  },
  color: "#196097",
  padding: "0px 0 0 24px",
  ":hover": {
    color: "#196097"
  },
  cursor: "pointer"
});

const Header = ({ link }) => {
  return (
    <div className={headerStyle}>
      <a href={link} aria-label="Back" className={linkStyle}>
        Back to gift cards
      </a>
    </div>
  );
};

export default connect(
  state => ({
    giftCards: state.giftCards,
    order: state.order
  }),
  {
    getGiftCardPage,
    getGiftCardEvents
  }
)(GiftCardEventPage);



// WEBPACK FOOTER //
// ./routes/giftCards/GiftCardEventPage.js